var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchTable(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 29,
    rx: 14.5,
    stroke: "#545D5B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0229 16.0229L15.8319 16.1871C15.254 16.6839 14.5053 16.9821 13.6903 16.9821C11.8723 16.9821 10.3987 15.5084 10.3987 13.6904C10.3987 11.8724 11.8723 10.3987 13.6903 10.3987C15.5084 10.3987 16.982 11.8724 16.982 13.6904C16.982 14.5053 16.6838 15.2541 16.187 15.832L16.0229 16.0229ZM16.8153 16.8154H16.9829L19.3944 19.2317L19.2317 19.3945L16.8153 16.983V16.8154ZM10.5653 13.6904C10.5653 15.4191 11.9617 16.8154 13.6903 16.8154C15.419 16.8154 16.8153 15.4191 16.8153 13.6904C16.8153 11.9618 15.419 10.5654 13.6903 10.5654C11.9617 10.5654 10.5653 11.9618 10.5653 13.6904Z",
    fill: "white",
    stroke: "#545D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchTable);
export default __webpack_public_path__ + "static/media/search-table.89d2b9522c46084ee70a3f421d7f3146.svg";
export { ForwardRef as ReactComponent };